import { HHStack, HHTypography } from '@hinge-health/react-component-library';

import { formatCurrency } from '../../../utils/currency-helpers';
import { FormattedPriceAdjustment } from '../utils';

interface PriceAdjustmentDetailsProps {
  adjustmentEntries: FormattedPriceAdjustment[];
  isBillAmountValid: boolean;
  baseCharge: number;
  billAmount: number;
  currency: string | null;
}

const PriceAdjustmentDetails = ({
  adjustmentEntries,
  isBillAmountValid,
  billAmount,
  baseCharge,
  currency,
}: PriceAdjustmentDetailsProps): JSX.Element => (
  <HHStack spacing={1}>
    <HHStack direction="row" justifyContent="space-between" alignItems="center">
      <HHTypography hhVariant="body">Base Charge</HHTypography>
      <HHTypography hhVariant="body">
        {formatCurrency(baseCharge, currency, true)}
      </HHTypography>
    </HHStack>

    {adjustmentEntries.length > 0 &&
      adjustmentEntries.map(adjustment => (
        <HHStack
          key={adjustment.key}
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          paddingLeft={2}
        >
          <HHTypography hhVariant="body">{adjustment.label}</HHTypography>
          <HHTypography hhVariant="body">
            {formatCurrency(adjustment.amount, currency, true)}
          </HHTypography>
        </HHStack>
      ))}

    <HHStack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      borderTop={1}
      borderColor="divider"
    >
      <HHTypography hhVariant="body">Final Bill Amount</HHTypography>
      <HHTypography
        hhVariant="body"
        color={isBillAmountValid ? 'inherit' : 'error'}
      >
        {typeof billAmount === 'number'
          ? formatCurrency(billAmount, currency, true)
          : '--'}
      </HHTypography>
    </HHStack>
  </HHStack>
);

export default PriceAdjustmentDetails;
